// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__7Z-D0","gfeWrapper":"CalendarEvent_gfeWrapper__3sQXW"};